import { Autocomplete, TextField, FormHelperText } from "@mui/material";
import { Controller, Control, FieldValues, Path, FieldError } from "react-hook-form";

// Definición del tipo de opción
type OptionType<T> = { label: string; value: T };

interface InputSelectSearchProps<K extends FieldValues, T extends string | number> {
  name: Path<K>;
  control: Control<K>;
  error?: FieldError;
  options: OptionType<T>[];
  label?: string | React.ReactNode;
  disabled?: boolean;
  clearable?: boolean;
  onChange?: (selectedValue: T | null) => void;
}

export default function InputSelectSearch<K extends FieldValues, T extends string | number>({
  name,
  control,
  error,
  options,
  label,
  disabled,
  clearable = false,
  onChange,
}: InputSelectSearchProps<K, T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          options={options}
          getOptionLabel={(option) => option.label}
          // isOptionEqualToValue={(option, value) => option.value === value}
          noOptionsText='No hay opciones'
          onChange={(_, newValue) => {
            const newSelectedValue = newValue ? newValue.value : null;
            field.onChange(newSelectedValue);
            onChange?.(newSelectedValue);
          }}
          value={options.find((option) => option.value === field.value) || null}
          disableClearable={!clearable}
          disabled={disabled}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              variant="standard"
              margin="dense"
              error={!!error}
              fullWidth
              helperText={error?.message}
            />
          )}
        />
      )}
    />
  );
}
